<template>
  <transition name="fade">
    <div class="upgrade-modal-overlay" v-if="show">
      <div class="upgrade-modal">
        <div class="upgrade-modal__header">
          <button class="close-btn" @click="$emit('close')">×</button>
        </div>

        <div class="upgrade-modal__content">
          <div class="content-left">
            <h1 class="main-title">Limited Time Offer — Upgrade to Premium</h1>
            <p class="subtitle">
              &bull; Exclusive for Existing Customers <br>
              &bull; Requires migration to the new app <br>
              &bull; Offer expires on September 15, 2025
            </p>

            <div class="features-section">
              <div class="features-columns">
                <div class="features-col">
                  <p class="features-intro">New App Benefits:</p>
                  <ul class="features-list">
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Custom payout formulas</li>
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Assignable payout profiles</li>
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Redesigned, faster UI</li>
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Optimized performance</li>
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Ongoing feature updates</li>
                  </ul>
                </div>
                <div class="features-col">
                  <p class="features-intro">Premium Plan Features:</p>
                  <ul class="features-list">
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Unlimited Consignors</li>
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Consignor Portal</li>
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Branded Consignor Portal</li>
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Live Chat Support</li>
                    <li><span class="checkmark"><i class="fas fa-check"></i></span> Free Onboarding + Setup</li>
                  </ul>
                </div>
              </div>
              <p class="coming-soon"><i class="fas fa-rocket-launch"></i> Coming Soon: Payment Integrations, Consignor Messaging</p>
            </div>

            <div class="action-buttons">
              <div class="notice">
                <strong>No immediate change or charge.</strong>
                <span>
                Clicking <em>"Lock In Offer"</em> reserves your discounted price for 12 months
                and informs us to begin migrating your data and schedule a walkthrough. Billing updates only after migration to the new app is complete.
              </span>
              </div>

              <div class="button-and-checkbox">
                <button
                  class="btn-primary hide-for-small"
                  :class="{ disabled: !confirmationChecked }"
                  :disabled="!confirmationChecked"
                  @click="upgradeToV3">
                  Lock In Offer
                </button>

                <div class="confirmation-checkbox hide-for-small">
                  <label>
                    <input type="checkbox" v-model="confirmationChecked">
                    I understand and agree to proceed
                  </label>
                </div>
              </div>
            </div>

            <p class="disclaimer hide-for-small">Offer valid for existing customers only. Pricing locked for 12 months.
              <br><strong>Offer expires September 15, 2025</strong>.</p>
          </div>

          <div class="content-right">
            <div class="exclusiveOffer-logoBox">
              <img src="../../../assets/img/LimitedTimeOfferAd/v-consignment-logo.png" alt="" width="88" class="exclusiveOffer-logo">
            </div>
            <img src="../../../assets/img/LimitedTimeOfferAd/monthly-price-discount-39.png" alt="" width="332" class="exclusiveOffer-priceTag">
            <img src="../../../assets/img/LimitedTimeOfferAd/graphic-element-01.png" alt="" width="257" class="exclusiveOffer-graphicElement">
            <p>Exclusive for existing customers only.</p>

            <div class="action-buttons mobile-buttons">

              <div class="confirmation-checkbox">
                <label>
                  <input type="checkbox" v-model="confirmationChecked">
                  I understand and agree to proceed
                </label>
              </div>

              <button
                class="btn-primary"
                :class="{ disabled: !confirmationChecked }"
                :disabled="!confirmationChecked"
                @click="upgradeToV3">
                Claim This Offer
              </button>
              <p class="disclaimer">Offer valid for existing customers only. Pricing locked for 12 months.
                <br><strong>Offer expires September 15, 2025</strong>.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import client from '@/mixins/client'

export default {
  name: 'UpgradeModal',
  mixins: [client],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    shop: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      confirmationChecked: false
    }
  },
  methods: {
    upgradeToV3 () {
      if (!this.confirmationChecked) return

      const shopDomain = this.shop && this.shop.myshopify_domain ? this.shop.myshopify_domain : ''

      this.request('patch', '/shopify/shops/confirm-upgrade/', {
        shop: shopDomain
      }).then(response => {
        this.$store.state.shop.agree_to_upgrade = true
        this.$store.state.shop.agree_to_upgrade_datetime = new Date().toISOString()
        this.$emit('close')
      }).catch(error => {
        console.error('Upgrade request failed:', error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* Modal styles */
.upgrade-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.upgrade-modal {
  background: #1a1a1a;
  border-radius: 16px;
  max-width: 950px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  color: white;

  .notice {
    color: #ffc209;
    font-size: 14px;
    margin: 0 0 16px 0;
    line-height: 1.4;
    strong {
      color: #fff;
    }
    em {
      font-weight: bold;
    }
  }

  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    color: #888;
    font-size: 24px;
    cursor: pointer;
    z-index: 10;
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      color: white;
    }
  }

  &__content {
    display: grid;
    grid-template-columns: 1fr 400px;
    min-height: 500px;
  }
}

.content-left {
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .main-title {
    font-size: 32px;
    font-weight: bold;
    line-height: 1.2;
    margin: 0 0 8px 0;
    color: white;
  }

  .subtitle {
    color: #ffc209;
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 32px 0;
  }

  .features-section {
    flex: 1;

    .features-columns {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 8px 32px;
      align-items: start;
    }

    .features-col {
      min-width: 0;
    }

    .features-intro {
      color: #ccc;
      margin: 0 0 16px 0;
      font-size: 16px;
    }

    .features-list {
      list-style: none;
      padding: 0;
      margin: 0 0 16px 0;

      li {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 1.2;

        .checkmark {
          background: #4caf50;
          color: white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 12px;
          font-size: 12px;
          font-weight: bold;
        }
      }
    }

    .coming-soon {
      color: #ddd;
      font-size: 15px;
      margin: 0;
      font-weight: bold;
    }

    @media (max-width: 768px) {
      .features-columns {
        grid-template-columns: 1fr;
        gap: 12px;
      }
    }
  }

  .action-buttons {
    margin: 32px 0 16px 0;

    .btn-secondary {
      background: #333;
      color: #ccc;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 16px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #444;
        color: white;
      }
    }

    .btn-primary {
      background: #ffc107;
      color: #000;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #ffca28;
        transform: translateY(-1px);
      }
    }
  }

  .disclaimer {
    color: #888;
    font-size: 12px;
    margin: 0;
    line-height: 1.4;
  }
}

.content-right {
  background: #4a148c url("../../../assets/img/LimitedTimeOfferAd/LimitedTimeUpgradeOfferBG.png") no-repeat right top / cover;
  padding: 20px;
  position: relative;
  overflow: hidden;
  text-align: center;

  img {
    max-width: 100%;
  }

  .exclusiveOffer-logoBox {
    text-align: left;
    margin: 10px 0 20px 25px;
  }

  .action-buttons {
    .btn-secondary {
      background: #333;
      color: #ccc;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 16px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #444;
        color: white;
      }
    }

    .btn-primary {
      background: #ffc107;
      color: #000;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #ffca28;
        transform: translateY(-1px);
      }
    }

    .disclaimer {
      color: #ddd;
      font-size: 12px;
      margin: 0;
      line-height: 1.4;
    }
  }
}

.mobile-buttons {
  display: none;
}

@media (max-width: 768px) {
  .upgrade-modal {
    &__content {
      grid-template-columns: 60% 40%;
    }
  }

  .content-left {
    padding: 30px 20px;

    .main-title {
      font-size: 24px;
    }
  }

  .content-right {
    padding: 30px 10px;
  }

  .mobile-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
  }

  .hide-for-small {
    display: none !important;
  }
}

@media (min-width: 769px) {
  .mobile-buttons {
    display: none !important;
  }
}

.confirmation-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}

.confirmation-dialog {
  background: #2a2a2a;
  border-radius: 12px;
  padding: 30px;
  max-width: 400px;
  text-align: center;

  h3 {
    color: white;
    margin: 0 0 16px 0;
    font-size: 20px;
  }

  p {
    color: #ccc;
    margin: 0 0 24px 0;
    line-height: 1.4;
  }
}

.confirmation-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.button-and-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.confirmation-checkbox {
  margin-top: 7px;
  flex: 1;

  label {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    color: #ccc;
    font-size: 14px;
    line-height: 1.3;
    cursor: pointer;
    letter-spacing: 0;
  }

  input[type="checkbox"] {
    margin-top: 2px;
  }
}

.btn-primary.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/components/UpgradeModal.vue